import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import {
  PageHeader as UiPageHeader,
  type PageHeaderProps as UiPageHeaderProps,
} from '@repo/ui/src/components/page-header';
import { AdminOnlyTooltip } from './AdminOnlyTooltip';

export type { PageHeaderAction } from '@repo/ui/src/components/page-header';
// Non-component re-export from a component file, deliberately: call sites
// import both the wrapper and its shared action class from one module path.
// eslint-disable-next-line react-refresh/only-export-components
export { pageHeaderActionClass } from '@repo/ui/src/components/page-header-actions';
export type PageHeaderProps = Omit<UiPageHeaderProps, 'linkComponent' | 'moreLabel' | 'renderDisabled'>;

/** Dashboard-bound PageHeader: react-router Link + i18n ⋮ label + the tooltip
 *  that explains a disabled action. The sidebar trigger is NOT part of the
 *  header — it lives in the content area's top bar (DashboardLayout), per
 *  handoff 01-shell §2 (shadcn sidebar-07 convention). */
export function PageHeader(props: PageHeaderProps) {
  const { t } = useTranslation('common');
  return (
    <UiPageHeader
      {...props}
      linkComponent={Link}
      moreLabel={t('moreActions')}
      renderDisabled={(node, reason) => (
        // The wrapper span has to stay a flex box that inherits the action's
        // mobile stretch: `pageHeaderActionClass` puts `flex-1` on the button,
        // and an inline span between it and the action row would collapse the
        // button to its intrinsic width on phones.
        <AdminOnlyTooltip show reason={reason} className="flex flex-1 sm:flex-none">
          {node}
        </AdminOnlyTooltip>
      )}
    />
  );
}
